import { timesheetsOverviewState } from '../timesheets/timesheets.states';
import {
    EmployeesService,
    IAccount,
    IShift,
    ShiftService,
    ITeam,
    Masterdata,
    IEmployee
} from '../../services';
import { IEmployeeSalaryScale } from '../../services/employees.service';
import * as moment from 'moment';
import { AuthService } from "../../authorization/services/index";
import { AccountsService } from '../../services/accounts.service';
import { IEmployeeAvailability } from '../../services/employeeAvailability.service';

interface IResolve {
    shift: IShift;
    accounts: IAccount[];
    functions: Masterdata[];
    employees: IEmployee;
    statuses: Masterdata[];
}

interface IScope extends ng.IScope {
    shiftForm: ng.IFormController;
}

class ShiftListItemController implements ng.IComponentController {
    currentShiftStatus: number;
    private onChange: any;
    private employees: any;
    private functions: Masterdata[];
    private availableFunctions: Masterdata[];
    private statuses: Masterdata[];
    private currentAccount: IAccount;
    private currentLocation: any;
    public employeeCaoWarning: string;
    public functionCaoWarning: string;
    private selectedEmployeeSalaryScales: IEmployeeSalaryScale[];
    private usedCaoName: string;
    private accounts: IAccount[];
    private locations: any;
    private teams: ITeam[];
    private shift: IShift;
    private employeeNote: string;
    private employeeAvailability: IEmployeeAvailability[];
    private selectedEmployee: any;
    private mode: string;
    private currentDate: any;

    private sortType: string;

    public isBackoffice = false;
    public isCustomer = false;
    public isEmployee = false;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private AccountsService: AccountsService,
        private AuthService: AuthService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private $timeout: ng.ITimeoutService,
        private $scope: IScope,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.onChange({ type: 'open', data: this.shift });

        // Initialiseer availableFunctions - alle functies zijn nu beschikbaar (geen filter meer)
        this.availableFunctions = this.functions || [];
        
        // Initialiseer employee CAO warning
        this.employeeCaoWarning = '';
        
        // Initialiseer functie CAO warning
        this.functionCaoWarning = '';

        // Controleer of functions beschikbaar zijn
        if (!this.functions) {
            this.functions = [];
        }
        // Update availableFunctions als functions beschikbaar zijn
        if (this.functions && this.functions.length > 0) {
            this.availableFunctions = this.functions;
        }

        if (this.employees && !this.employees.find(e => e.displayName === '--- Geen ---')) {
            var emp = new IEmployee();
            emp.displayName = '--- Geen ---';
            this.employees.push(emp);
        }

        if (this.shift) {
            if (moment().isAfter(this.shift.start)) {
                this.shift.isInThePast = true;
            }
            this.currentShiftStatus = this.shift.status;
        } else {
            this.shift = new IShift();
            this.shift.start = this.roundMinutes(new Date());
            this.shift.end = moment(this.shift.start).add(8, 'hour').toDate();
            this.shift.status = 2;

            // if (this.AuthService.hasRole('customer')) {
            //     this.shift.status = 6;
            // }
            if (this.$stateParams['status']) {
                this.shift.status = this.$stateParams['status'];
            }
            this.shift.employeeId = null;
        }

        if (this.AuthService.hasRole('customer')) {
            this.shift.teamLocationAccountId = this.AuthService.getTokenData().customerId;
        }

        if (this.shift.teamLocationAccountId) {
            this.AccountsService.get(this.shift.teamLocationAccountId).then((account: IAccount) => {
                this.currentAccount = account;
                // Update CAO naam (roept automatisch validateEmployeeCao aan)
                this.updateUsedCaoName();
            });
            this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
                this.locations = result;
                if (this.shift.teamLocationId) {
                    let location = this.locations.find(item => item.id === this.shift.teamLocationId);
                    this.currentLocation = location;
                    this.teams = location ? location.teams : [];
                    
                    // Update CAO naam
                    this.updateUsedCaoName();
                }
            });
        }

        this.currentDate = new Date(Date.now());

        this.isBackoffice = this.AuthService.hasRole('backoffice');
        this.isCustomer = this.AuthService.hasRole('customer');
        this.isEmployee = this.AuthService.hasRole('employee');

        // Watch voor functie wijzigingen
        this.$scope.$watch(() => this.shift.functionId, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.$timeout(() => {
                    // Valideer employee CAO als er een employee is geselecteerd
                    if (this.shift.employeeId) {
                        this.validateEmployeeCao();
                    }
                }, 100);
            }
        });
    }

    $onDestroy = () => {
        this.onChange({ type: 'close', data: this.shift });
    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    // startDateBeforeRender($dates) {
    // }

    // endDateBeforeRender($view, $dates) {
    //     // console.log('endDateBeforeRender');
    //     if (this.shift.start) {
    //         var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');

    //         $dates.filter(function (date) {
    //             return date.localDateValue() <= activeDate.valueOf();
    //         }).forEach(function (date) {
    //             date.selectable = false;
    //         });
    //     }
    // }

    public selectEmployee = () => {
        if (this.shift.employeeId) {
            this.shift.status = 6;
        } else {
            this.shift.status = 2;
        }
        // Valideer CAO wanneer employee wordt geselecteerd
        this.validateEmployeeCao();
    }

    public selectedAccount() {
        this.AccountsService.get(this.shift.teamLocationAccountId).then((account: IAccount) => {
            this.currentAccount = account;
            // Update CAO naam (roept automatisch validateEmployeeCao aan)
            this.updateUsedCaoName();
        });
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
            this.locations = result;
        });
        // Alle functies zijn nu beschikbaar (geen filter meer op accountFunctions)
        this.availableFunctions = this.functions || [];
    }

    public locationSelected() {
        if (this.shift.teamLocationId) {
            let location = this.locations.find(item => item.id === this.shift.teamLocationId);
            this.currentLocation = location;
            this.teams = location ? location.teams : [];
            
            // Update CAO naam (roept automatisch validateEmployeeCao aan)
            this.updateUsedCaoName();
        }
    }

    private updateUsedCaoName = () => {
        // Reset cached naam
        this.usedCaoName = '';
        
        // Check location eerst (override)
        if (this.currentLocation && this.currentLocation.salaryScaleGroup && this.currentLocation.salaryScaleGroup.name) {
            this.usedCaoName = this.currentLocation.salaryScaleGroup.name;
        } else if (this.currentAccount && this.currentAccount.salaryScaleGroup && this.currentAccount.salaryScaleGroup.name) {
            // Check account (fallback)
            this.usedCaoName = this.currentAccount.salaryScaleGroup.name;
        }
        
        // Valideer employee CAO wanneer CAO verandert
        if (this.shift.employeeId) {
            this.$timeout(() => {
                this.validateEmployeeCao();
            }, 100);
        }
    }

    public getUsedCaoName = (): string => {
        return this.usedCaoName || '';
    }

    public showSleepShiftOption = (): boolean => {
        if (this.shift && this.shift.sleepShiftOrtRulesActive) {
            return true;
        }
        return this.isSleepShiftOrtRulesActive();
    }

    private isSleepShiftOrtRulesActive = (): boolean => {
        if (!this.currentAccount) {
            return false;
        }

        const override = Number(this.currentAccount.sleepShiftOrtRulesOverride || 0);
        if (override === 2) {
            return false;
        }
        if (override === 1) {
            return true;
        }

        const locationCao = this.currentLocation && this.currentLocation.salaryScaleGroup;
        const accountCao = this.currentAccount.salaryScaleGroup;
        const cao = locationCao || accountCao;
        return !!(cao && cao.enableSleepShiftOrtRules);
    }


    private validateEmployeeCao = () => {
        this.employeeCaoWarning = '';
        
        // Controleer of alle benodigde velden zijn ingevuld
        if (!this.shift.employeeId || !this.currentAccount) {
            return;
        }
        
        // Controleer of employee ZZP is - geen CAO waarschuwing voor ZZP medewerkers
        const selectedEmployee = this.employees.find(e => e.id === this.shift.employeeId);
        if (selectedEmployee && selectedEmployee.zzp === true) {
            return; // ZZP medewerkers hebben geen CAO waarschuwing nodig
        }
        
        // Als employee niet in array staat of zzp property niet beschikbaar, haal employee op
        if (!selectedEmployee || selectedEmployee.zzp === undefined) {
            this.EmployeesService.get(this.shift.employeeId).then((employee: IEmployee) => {
                if (employee && employee.zzp === true) {
                    return; // ZZP medewerkers hebben geen CAO waarschuwing nodig
                }
                // Continue met CAO validatie als niet ZZP
                this.performCaoValidation();
            }).catch(() => {
                // Bij fout, continue met CAO validatie
                this.performCaoValidation();
            });
            return;
        }
        
        // Continue met CAO validatie als niet ZZP
        this.performCaoValidation();
    }
    
    private performCaoValidation = () => {
        // Bepaal welke CAO gebruikt moet worden: location override of account CAO
        const requiredCaoGroup = this.currentLocation && this.currentLocation.salaryScaleGroup 
            ? this.currentLocation.salaryScaleGroup 
            : (this.currentAccount.salaryScaleGroup || null);
        
        if (!requiredCaoGroup || !requiredCaoGroup.id) {
            return;
        }
        
        // Haal employee salary scales op en controleer of employee de juiste CAO heeft
        this.EmployeesService.getSalaryScales(this.shift.employeeId).then((salaryScales) => {
            this.selectedEmployeeSalaryScales = salaryScales;
            
            const hasRequiredCao = salaryScales.some(ess => 
                ess.salaryScale && ess.salaryScale.salaryScaleGroupId === requiredCaoGroup.id
            );
            
            if (!hasRequiredCao) {
                const functionName = this.functions.find(f => f.id === this.shift.functionId);
                const functionDisplayName = functionName ? functionName.name : 'deze functie';
                this.employeeCaoWarning = `Deze medewerker heeft niet de juiste CAO (${requiredCaoGroup.name}) voor ${functionDisplayName}.`;
            }
        }).catch(() => {
            this.employeeCaoWarning = 'Kon de CAO informatie van de medewerker niet ophalen.';
        });
    }

    public submitShift(after = null) {
        this.$scope.shiftForm.$setSubmitted();
        if (this.$scope.shiftForm.$valid) {
            if (this.isCustomer && moment().isAfter(this.shift.start)) {
                this.SweetAlert.swal('Dienst in het verleden', 'U kunt geen dienst in het verleden creëren.', 'warning');
            } else if (moment(this.shift.start).isAfter(this.shift.end)) {
                this.SweetAlert.swal('Let op!', 'Eindtijd ligt voor starttijd.', 'warning');
            } else if (moment().isAfter(this.shift.start)) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Deze dienst is in het verleden. Weet je zeker dit zeker?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja, opslaan',
                    cancelButtonText: 'Nee, annuleren',
                }, (isConfirm) => {
                    if (isConfirm) {
                        this.currentShiftStatus = this.shift.status;
                        this.save(after);
                    } else {

                    }
                });
            } else if ((this.shift.status === 92 || this.shift.status === 7) && moment().add(4, 'day').isAfter(moment(this.shift.start))) {
                // console.log("HERE")
                if (!this.shift.employeeId) {
                    // console.log("1")
                    this.SweetAlert.swal({
                        title: 'Let op!',
                        text: 'Let op: de dienst begint over minder dan 96 uur. Er is geen medewerker geselecteerd waarop een decalartie kan worden aangemaakt. Je kunt deze dienst niet annuleren',
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#2ECC71',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Stop',
                    }, (isConfirm) => {
                        if (isConfirm) {
                        } else {
                        }
                    });
                } else {
                    // console.log("2")
                    this.SweetAlert.swal({
                        title: 'Let op!',
                        text: 'Let op: de dienst begint over minder dan 96 uur. Er worden automatisch een declaratie aangemaakt. Weet u zeker dat u de dienst wilt annuleren?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#2ECC71',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ja, opslaan',
                        cancelButtonText: 'Nee, annuleren',
                    }, (isConfirm) => {
                        if (isConfirm) {
                            this.shift.status = 7;
                            this.currentShiftStatus = this.shift.status;
                            this.save(after);
                        } else {
                        }
                    });
                }
            } else if ((this.currentShiftStatus === 7  && this.shift.status != 7)) {
                // console.log("3")
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Let op: Deze dienst had status Geannuleerd 96 uur. Bij het opslaan zullen alle declaraties worden verwijderd. Weet je zeker dat je dit wilt?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja, opslaan',
                    cancelButtonText: 'Nee, annuleren',
                }, (isConfirm) => {
                    if (isConfirm) {
                        this.currentShiftStatus = this.shift.status;
                        this.save(after);
                    } else {
                    }
                });
            } else {
                this.currentShiftStatus = this.shift.status;
                this.save(after);
            }
        }
    }

    public save = (after) => {
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");

        if (!this.shift.id) {
            this.ShiftService.post(this.shift).then((data) => {
                this.shift = data;
                this.handleAfterSubmit(after, 'new');
            });
        } else {
            this.ShiftService.put(this.shift.id, this.shift).then((data) => {
                this.shift = data;
                this.handleAfterSubmit(after, 'updated');
            });
        }
    }

    private deleteShift = () => {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze dienst wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.ShiftService.delete(this.shift.id).then(() => {
                    this.onChange({ type: 'deleted', data: this.shift });
                    this.$state.go('^');
                });
            } else {

            }
        });
    }

    private handleAfterSubmit = (after, type) => {
        switch (after) {
            case "copy": {
                this.onChange({ type: 'copy', data: this.shift });
                //this.$state.go('.', {'id': ''}, {notify: false});
                this.shift.id = null;
                // this.shift.start = moment(this.shift.start).add(1, 'day').toDate();
                // this.shift.end = moment(this.shift.end).add(1, 'day').toDate();
                if (moment().isAfter(this.shift.start)) {
                    this.shift.isInThePast = true;
                } else {
                    this.shift.isInThePast = false;
                }

                break;
            }
            case "new": {
                this.onChange({ type: 'copy', data: this.shift });
                this.shift = null;
                this.$state.go('shifts.list.item', { 'id': '' });
                break;
            }
            default: {
                this.$state.go('shifts.list.item', { 'id': this.shift.id });
                this.onChange({ type: "new", data: this.shift });
            }
        }
    }
}

export const shiftListItemComponent: ng.IComponentOptions = {
    bindings: {
        shift: '<',
        employees: '<',
        statuses: '<',
        accounts: '<',
        functions: '<',
        onChange: '&',
    },
    controller: ShiftListItemController,
    template: <string>require('./shift.list.item.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.list.item.component.ts